module.exports = __webpack_public_path__ + "img/motor_no75.10042c63.jpg";